export const actionTypes = {
  WORKFLOW_REQUEST: "WORKFLOW_REQUEST",
  WORKFLOW_REQUEST_SUCCESS: "WORKFLOW_REQUEST_SUCCESS",
  WORKFLOW_REQUEST_FAILURE: "WORKFLOW_REQUEST_FAILURE",
  ADD_WORKFLOW_TO_STATE: "ADD_WORKFLOW_TO_STATE",
  ADD_WORKFLOW_STEP_TO_STATE: "ADD_WORKFLOW_STEP_TO_STATE",
  ADD_WORKFLOW_STEP_CONFIGURATION_TO_STATE:
    "ADD_WORKFLOW_STEP_CONFIGURATION_TO_STATE",
  ADD_MODIFIED_WORKFLOW_TO_STATE: "ADD_MODIFIED_WORKFLOW_TO_STATE",
  ADD_MODIFIED_WORKFLOW_STEP_TO_STATE: "ADD_MODIFIED_WORKFLOW_STEP_TO_STATE",
  ADD_MODIFIED_WORKFLOW_STEP_CONFIGURATION_TO_STATE:
    "ADD_MODIFIED_WORKFLOW_STEP_CONFIGURATION_TO_STATE",
  CREATE_WORKFLOW_REQUEST: "CREATE_WORKFLOW_REQUEST",
  CREATE_WORKFLOW_REQUEST_SUCCESS: "CREATE_WORKFLOW_REQUEST_SUCCESS",
  CREATE_WORKFLOW_REQUEST_FAILURE: "CREATE_WORKFLOW_REQUEST_FAILURE",
  UPDATE_WORKFLOW_REQUEST: "UPDATE_WORKFLOW_REQUEST",
  UPDATE_WORKFLOW_REQUEST_SUCCESS: "UPDATE_WORKFLOW_REQUEST_SUCCESS",
  UPDATE_WORKFLOW_REQUEST_FAILURE: "UPDATE_WORKFLOW_REQUEST_FAILURE",
  DELETE_WORKFLOW_REQUEST: "DELETE_WORKFLOW_REQUEST",
  DELETE_WORKFLOW_REQUEST_SUCCESS: "DELETE_WORKFLOW_REQUEST_SUCCESS",
  DELETE_WORKFLOW_REQUEST_FAILURE: "DELETE_WORKFLOW_REQUEST_FAILURE",
  WORKFLOW_STEP_REQUEST: "WORKFLOW_STEP_REQUEST",
  WORKFLOW_STEP_REQUEST_SUCCESS: "WORKFLOW_STEP_REQUEST_SUCCESS",
  WORKFLOW_STEP_REQUEST_FAILURE: "WORKFLOW_STEP_REQUEST_FAILURE",
  CREATE_WORKFLOW_STEP_REQUEST: "CREATE_WORKFLOW_STEP_REQUEST",
  CREATE_WORKFLOW_STEP_REQUEST_SUCCESS: "CREATE_WORKFLOW_STEP_REQUEST_SUCCESS",
  CREATE_WORKFLOW_STEP_REQUEST_FAILURE: "CREATE_WORKFLOW_STEP_REQUEST_FAILURE",
  UPDATE_WORKFLOW_STEP_REQUEST: "UPDATE_WORKFLOW_STEP_REQUEST",
  UPDATE_WORKFLOW_STEP_REQUEST_SUCCESS: "UPDATE_WORKFLOW_STEP_REQUEST_SUCCESS",
  UPDATE_WORKFLOW_STEP_REQUEST_FAILURE: "UPDATE_WORKFLOW_STEP_REQUEST_FAILURE",
  DELETE_WORKFLOW_STEP_REQUEST: "DELETE_WORKFLOW_STEP_REQUEST",
  DELETE_WORKFLOW_STEP_REQUEST_SUCCESS: "DELETE_WORKFLOW_STEP_REQUEST_SUCCESS",
  DELETE_WORKFLOW_STEP_REQUEST_FAILURE: "DELETE_WORKFLOW_STEP_REQUEST_FAILURE",
  WORKFLOW_STEP_CONFIGURATION_REQUEST: "WORKFLOW_STEP_CONFIGURATION_REQUEST",
  WORKFLOW_STEP_CONFIGURATION_REQUEST_SUCCESS:
    "WORKFLOW_STEP_CONFIGURATION_REQUEST_SUCCESS",
  WORKFLOW_STEP_CONFIGURATION_REQUEST_FAILURE:
    "WORKFLOW_STEP_CONFIGURATION_REQUEST_FAILURE",
  CREATE_WORKFLOW_STEP_CONFIGURATION_REQUEST:
    "CREATE_WORKFLOW_STEP_CONFIGURATION_REQUEST",
  CREATE_WORKFLOW_STEP_CONFIGURATION_REQUEST_SUCCESS:
    "CREATE_WORKFLOW_STEP_CONFIGURATION_REQUEST_SUCCESS",
  CREATE_WORKFLOW_STEP_CONFIGURATION_REQUEST_FAILURE:
    "CREATE_WORKFLOW_STEP_CONFIGURATION_REQUEST_FAILURE",
  UPDATE_WORKFLOW_STEP_CONFIGURATION_REQUEST:
    "UPDATE_WORKFLOW_STEP_CONFIGURATION_REQUEST",
  UPDATE_WORKFLOW_STEP_CONFIGURATION_REQUEST_SUCCESS:
    "UPDATE_WORKFLOW_STEP_CONFIGURATION_REQUEST_SUCCESS",
  UPDATE_WORKFLOW_STEP_CONFIGURATION_REQUEST_FAILURE:
    "UPDATE_WORKFLOW_STEP_CONFIGURATION_REQUEST_FAILURE",
  DELETE_WORKFLOW_STEP_CONFIGURATION_REQUEST:
    "DELETE_WORKFLOW_STEP_CONFIGURATION_REQUEST",
  DELETE_WORKFLOW_STEP_CONFIGURATION_REQUEST_SUCCESS:
    "DELETE_WORKFLOW_STEP_CONFIGURATION_REQUEST_SUCCESS",
  DELETE_WORKFLOW_STEP_CONFIGURATION_REQUEST_FAILURE:
    "DELETE_WORKFLOW_STEP_CONFIGURATION_REQUEST_FAILURE",
  MATCHING_RULES: "MATCHING_RULES",
  MATCHING_RULES_SUCCESS: "MATCHING_RULES_SUCCESS",
  MATCHING_RULES_FAILURE: "MATCHING_RULES_FAILURE",
  SAVE_WORKFLOW: "SAVE_WORKFLOW",
  SAVE_WORKFLOW_SUCCESS: "SAVE_WORKFLOW_SUCCESS",
  SAVE_WORKFLOW_FAILURE: "SAVE_WORKFLOW_FAILURE",
  GET_MATCHING_RULES_REQUEST: "GET_MATCHING_RULES_REQUEST",
  GET_MATCHING_RULES_REQUEST_SUCCESS: "GET_MATCHING_RULES_REQUEST_SUCCESS",
  GET_MATCHING_RULES_REQUEST_FAILURE: "GET_MATCHING_RULES_REQUEST_FAILURE",
  UPDATE_MATCHING_RULES: "UPDATE_MATCHING_RULES",
  UPDATE_MATCHING_RULES_SUCCESS: "UPDATE_MATCHING_RULES_SUCCESS",
  UPDATE_MATCHING_RULES_FAILURE: "UPDATE_MATCHING_RULES_FAILURE",
  RESET_MATCHING_RULES: "RESET_MATCHING_RULES",
  RESET_STATE_WORKFLOW_MANAGEMENT: "RESET_STATE_WORKFLOW_MANAGEMENT",
};

export const saveWorkflow = (payload: any[]) => ({
  type: actionTypes.SAVE_WORKFLOW,
  payload,
});

export const saveWorkflowSuccess = (payload: any[]) => ({
  type: actionTypes.SAVE_WORKFLOW_SUCCESS,
  payload,
});

export const saveWorkflowFailure = (err: Error) => ({
  type: actionTypes.SAVE_WORKFLOW_FAILURE,
  err,
});

export const workflowRequest = () => ({
  type: actionTypes.WORKFLOW_REQUEST,
});

export const workflowRequestSuccess = (payload: string[]) => ({
  type: actionTypes.WORKFLOW_REQUEST_SUCCESS,
  payload,
});

export const workflowRequestFailure = (err: Error) => ({
  type: actionTypes.WORKFLOW_REQUEST_FAILURE,
  err,
});

export const createWorkflow = (payload: any[]) => ({
  type: actionTypes.CREATE_WORKFLOW_REQUEST,
  payload,
});

export const createWorkflowSuccess = (payload: any[]) => ({
  type: actionTypes.CREATE_WORKFLOW_REQUEST_SUCCESS,
  payload,
});

export const createWorkflowFailure = (err: Error) => ({
  type: actionTypes.CREATE_WORKFLOW_REQUEST_FAILURE,
  err,
});

export const updateWorkflow = (payload: any[]) => ({
  type: actionTypes.UPDATE_WORKFLOW_REQUEST,
  payload,
});

export const updateWorkflowSuccess = (payload: any[]) => ({
  type: actionTypes.UPDATE_WORKFLOW_REQUEST_SUCCESS,
  payload,
});

export const updateWorkflowFailure = (err: Error) => ({
  type: actionTypes.UPDATE_WORKFLOW_REQUEST_FAILURE,
  err,
});

export const deleteWorkflow = (payload: any[]) => ({
  type: actionTypes.DELETE_WORKFLOW_REQUEST,
  payload,
});

export const deleteWorkflowSuccess = (payload: any[]) => ({
  type: actionTypes.DELETE_WORKFLOW_REQUEST_SUCCESS,
  payload,
});

export const deleteWorkflowFailure = (err: Error) => ({
  type: actionTypes.DELETE_WORKFLOW_REQUEST_FAILURE,
  err,
});

export const workflowStepRequest = () => ({
  type: actionTypes.WORKFLOW_STEP_REQUEST,
});

export const workflowStepRequestSuccess = (payload: string[]) => ({
  type: actionTypes.WORKFLOW_STEP_REQUEST_SUCCESS,
  payload,
});

export const workflowStepRequestFailure = (err: Error) => ({
  type: actionTypes.WORKFLOW_STEP_REQUEST_FAILURE,
  err,
});

export const createWorkflowStep = (payload: any[]) => ({
  type: actionTypes.CREATE_WORKFLOW_STEP_REQUEST,
  payload,
});

export const createWorkflowStepSuccess = (payload: any[]) => ({
  type: actionTypes.CREATE_WORKFLOW_STEP_REQUEST_SUCCESS,
  payload,
});

export const createWorkflowStepFailure = (err: Error) => ({
  type: actionTypes.CREATE_WORKFLOW_STEP_REQUEST_FAILURE,
  err,
});

export const updateWorkflowStep = (payload: any[]) => ({
  type: actionTypes.UPDATE_WORKFLOW_STEP_REQUEST,
  payload,
});

export const updateWorkflowStepSuccess = (payload: any[]) => ({
  type: actionTypes.UPDATE_WORKFLOW_STEP_REQUEST_SUCCESS,
  payload,
});

export const updateWorkflowStepFailure = (err: Error) => ({
  type: actionTypes.UPDATE_WORKFLOW_STEP_REQUEST_FAILURE,
  err,
});

export const deleteWorkflowStep = (payload: any[]) => ({
  type: actionTypes.DELETE_WORKFLOW_STEP_REQUEST,
  payload,
});

export const deleteWorkflowStepSuccess = (payload: any[]) => ({
  type: actionTypes.DELETE_WORKFLOW_STEP_REQUEST_SUCCESS,
  payload,
});

export const deleteWorkflowStepFailure = (err: Error) => ({
  type: actionTypes.DELETE_WORKFLOW_STEP_REQUEST_FAILURE,
  err,
});

export const workflowStepConfigurationRequest = () => ({
  type: actionTypes.WORKFLOW_STEP_CONFIGURATION_REQUEST,
});

export const workflowStepConfigurationRequestSuccess = (payload: any[]) => ({
  type: actionTypes.WORKFLOW_STEP_CONFIGURATION_REQUEST_SUCCESS,
  payload,
});

export const workflowStepConfigurationRequestFailure = (err: Error) => ({
  type: actionTypes.WORKFLOW_STEP_CONFIGURATION_REQUEST_FAILURE,
  err,
});

export const createWorkflowStepConfiguration = (payload: any[]) => ({
  type: actionTypes.CREATE_WORKFLOW_STEP_CONFIGURATION_REQUEST,
  payload,
});

export const createWorkflowStepConfigurationSuccess = (payload: any[]) => ({
  type: actionTypes.CREATE_WORKFLOW_STEP_CONFIGURATION_REQUEST_SUCCESS,
  payload,
});

export const createWorkflowStepConfigurationFailure = (err: Error) => ({
  type: actionTypes.CREATE_WORKFLOW_STEP_CONFIGURATION_REQUEST_FAILURE,
  err,
});

export const updateWorkflowStepConfiguration = (payload: any[]) => ({
  type: actionTypes.UPDATE_WORKFLOW_STEP_CONFIGURATION_REQUEST,
  payload,
});

export const updateWorkflowStepConfigurationSuccess = (payload: any[]) => ({
  type: actionTypes.UPDATE_WORKFLOW_STEP_CONFIGURATION_REQUEST_SUCCESS,
  payload,
});

export const updateWorkflowStepConfigurationFailure = (err: Error) => ({
  type: actionTypes.UPDATE_WORKFLOW_STEP_CONFIGURATION_REQUEST_FAILURE,
  err,
});

export const deleteWorkflowStepConfiguration = (payload: any[]) => ({
  type: actionTypes.DELETE_WORKFLOW_STEP_CONFIGURATION_REQUEST,
  payload,
});

export const deleteWorkflowStepConfigurationSuccess = (payload: any[]) => ({
  type: actionTypes.DELETE_WORKFLOW_STEP_CONFIGURATION_REQUEST_SUCCESS,
  payload,
});

export const deleteWorkflowStepConfigurationFailure = (err: Error) => ({
  type: actionTypes.DELETE_WORKFLOW_STEP_CONFIGURATION_REQUEST_FAILURE,
  err,
});

export const getMatchingRulesRequest = () => ({
  type: actionTypes.GET_MATCHING_RULES_REQUEST,
});

export const getMatchingRulesRequestSuccess = (payload: string[]) => ({
  type: actionTypes.GET_MATCHING_RULES_REQUEST_SUCCESS,
  payload,
});

export const getMatchingRulesRequestFailure = (err: Error) => ({
  type: actionTypes.GET_MATCHING_RULES_REQUEST_FAILURE,
  err,
});

export const updateMatchingRules = (payload: any[]) => ({
  type: actionTypes.UPDATE_MATCHING_RULES,
  payload,
});

export const updateMatchingRulesSuccess = (payload: any[]) => ({
  type: actionTypes.UPDATE_MATCHING_RULES_SUCCESS,
  payload,
});

export const updateMatchingRulesFailure = (err: Error) => ({
  type: actionTypes.UPDATE_MATCHING_RULES_FAILURE,
  err,
});

export const resetRulesAction = () => ({
  type: actionTypes.RESET_MATCHING_RULES,
});

export const resetState = () => ({
  type: actionTypes.RESET_STATE_WORKFLOW_MANAGEMENT,
});
